import { forwardRef } from 'react'

import { cn } from '../../../utils/cn'
import { Button, type ButtonProps } from '../../atoms/button'

export type KpiCardActionProps = Omit<ButtonProps, 'size' | 'iconOnly'>

/** The source's 24px secondary action, using the current Button behaviors. */
export const KpiCardAction = forwardRef<HTMLButtonElement, KpiCardActionProps>(
  ({ className, variant = 'secondary', ...props }, ref) => (
    <Button
      ref={ref}
      variant={variant}
      size='sm'
      className={cn(
        'h-6 rounded-sm border-0 px-2 py-[4.5px] text-[10px]/[15px] after:pointer-events-none after:absolute after:-inset-px after:rounded-[calc(var(--radius-sm)+1px)] after:border after:border-inherit',
        className
      )}
      {...props}
    />
  )
)
KpiCardAction.displayName = 'KpiCardAction'

export type KpiCardMoreActionProps = Omit<
  ButtonProps,
  'size' | 'iconOnly' | 'aria-label'
> & {
  'aria-label': string
}

export const KpiCardMoreAction = forwardRef<
  HTMLButtonElement,
  KpiCardMoreActionProps
>(({ className, variant = 'tertiary', ...props }, ref) => (
  <Button
    ref={ref}
    variant={variant}
    size='sm'
    iconOnly
    className={cn(
      'text-surface-body size-6 rounded-sm border-0 p-0 [&_[data-slot=icon]]:size-6 [&_[data-slot=icon]]:text-[24px]',
      className
    )}
    {...props}
  />
))
KpiCardMoreAction.displayName = 'KpiCardMoreAction'
